import { createFileRoute } from '@tanstack/react-router'
import { useCFAuth } from '@/lib/auth/cf-auth-context'
import { buildGettingStartedPath, hasBillingAccess } from '@/lib/cloudflare/billing-client'
import { LandingPage } from '@/components/landing-page'
import { AuthenticatedApp } from '@/components/authenticated-app'
import { StaticNav } from '@/components/static-nav'

export const Route = createFileRoute('/')({
  component: HomePage,
})

function HomePage() {
  const { status, user } = useCFAuth()

  if (status === 'authenticated') {
    if (!hasBillingAccess(user?.subscriptionStatus)) {
      window.location.replace(buildGettingStartedPath())
      return null
    }

    return <AuthenticatedApp />
  }

  return (
    <>
      <StaticNav />
      <LandingPage />
    </>
  )
}
